import { Instagram, Facebook, Twitter, Youtube, Music, Music2, Globe, BookOpen } from "lucide-react";

// Réseaux/liens du DÉFUNT (distincts du partage de la bougie).
// Les valeurs stockées sont des URLs complètes.
export const SOCIAL_PLATFORMS = [
  { key: "instagram", label: "Instagram", Icon: Instagram, color: "#E1306C", placeholder: "https://instagram.com/…" },
  { key: "facebook", label: "Facebook", Icon: Facebook, color: "#1877F2", placeholder: "https://facebook.com/…" },
  { key: "twitter", label: "X (Twitter)", Icon: Twitter, color: "#111111", placeholder: "https://x.com/…" },
  { key: "youtube", label: "YouTube", Icon: Youtube, color: "#FF0000", placeholder: "https://youtube.com/…" },
  { key: "tiktok", label: "TikTok", Icon: Music2, color: "#010101", placeholder: "https://tiktok.com/@…" },
  { key: "spotify", label: "Spotify", Icon: Music, color: "#1DB954", placeholder: "https://open.spotify.com/artist/…" },
  { key: "deezer", label: "Deezer", Icon: Music, color: "#A238FF", placeholder: "https://deezer.com/artist/…" },
  { key: "apple_music", label: "Apple Music", Icon: Music, color: "#FA243C", placeholder: "https://music.apple.com/…" },
  { key: "website", label: "Site officiel", Icon: Globe, color: "#0EA5E9", placeholder: "https://…" },
  { key: "wikipedia", label: "Wikipédia", Icon: BookOpen, color: "#8B8B8B", placeholder: "https://wikipedia.org/wiki/…" },
];

export const hasSocials = (s) => !!s && Object.values(s).some((v) => typeof v === "string" && v.trim());
